import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as o, normalizeClass as l, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconNetwork",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 1a.5.5 0 0 1 .5-.5h3A.5.5 0 0 1 8 1v3a.5.5 0 0 1-.5.5h-1v1h3a.5.5 0 0 1 .5.5v1.5h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h1v-1H3v1h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h1V6a.5.5 0 0 1 .5-.5h3v-1h-1A.5.5 0 0 1 4 4V1Zm1 2.5v-2h2v2H5Zm3.5 7v-2h2v2h-2Zm-7 0v-2h2v2h-2Z",
  fill: "currentColor"
}, null, -1), m = [
  u
], v = ["id"], f = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), p = [
  f
];
function g(e, I, r, w, b, t) {
  return o(), n("svg", {
    "aria-label": r.ariaLabel,
    class: l([t.iconSizeClass, "d-icon d-icon--network"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Network",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, p, 8, v)
    ])
  ], 10, c);
}
const z = /* @__PURE__ */ s(h, [["render", g]]);
export {
  z as default
};
//# sourceMappingURL=network.js.map
